import * as React from 'react';

import ERPInterventionScenarioModal, { type Props as ModalProps } from './ERPInterventionScenarioModal';

import type { ErpCountriesWithPriceTypeResponse } from 'com.cogvio.pricemonitor.api';
import {
	ErpCountriesWithPriceTypeError,
	ErpCountriesWithPriceTypeRequest,
} from '../api/ErpCountriesWithPriceTypeRequest';
import { useApiResult } from '~/infrastructure/mam/ApiHooks';

const ERPInterventionScenarioModalContainer = (
	props: Omit<ModalProps, 'erpCountriesResult'> & {
		modalVisible: boolean;
	}
) => {
	const [erpCountriesResult] = useApiResult<
		ErpCountriesWithPriceTypeRequest,
		ErpCountriesWithPriceTypeResponse,
		ErpCountriesWithPriceTypeError
	>(new ErpCountriesWithPriceTypeRequest(), []);

	const { modalVisible, ...modalProps } = props;

	return modalVisible ? <ERPInterventionScenarioModal erpCountriesResult={erpCountriesResult} {...modalProps} /> : null;
};

export default React.memo(ERPInterventionScenarioModalContainer);
